import { render, staticRenderFns } from "./grouped-question-element.vue?vue&type=template&id=4e04cdc1&scoped=true"
import script from "./grouped-question-element.vue?vue&type=script&lang=js"
export * from "./grouped-question-element.vue?vue&type=script&lang=js"
import style0 from "./grouped-question-element.vue?vue&type=style&index=0&id=4e04cdc1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e04cdc1",
  null
  
)

export default component.exports